// Bound an external promise that may never settle (a wedged third-party SDK, a
// stalled CDN). try/catch only handles a *reject* — a promise that never
// settles sails past it and the `await` hangs forever. This races the promise
// against a timer so the await always resolves or rejects (OMG-2147).
//
// The rejection is a distinct TimeoutError so a caller's catch can tell a real
// timeout (a wedged SDK — worth a Sentry capture) apart from the wrapped
// promise rejecting on its own (e.g. a drop-in rejecting invalid card fields —
// routine, must stay silent). Clears the timer on settle so a resolved promise
// doesn't leave a dangling handle.
export class TimeoutError extends Error {}

export function withTimeout<T>(
  promise: Promise<T>,
  ms: number,
  label: string,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout>;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(
      () => reject(new TimeoutError(`${label} timed out after ${ms}ms`)),
      ms,
    );
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}
